import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PORTAL, usePortal } from '../portalAuth';
import { trackEvent } from '../analytics';
import { STORE_BASE } from '../routeBase';

const PAY_LABEL = { unpaid: 'On account', pending: 'Payment pending', partial: 'Part paid', full: 'Paid', paid: 'Paid' };
const PAY_COLOR = { unpaid: '#92400e', pending: '#9a6a00', partial: '#1e40af', full: '#166534', paid: '#166534' };

export default function Orders() {
  const { customer, ready } = usePortal();
  const [orders, setOrders] = useState([]);
  const [currency, setCurrency] = useState('INR');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!localStorage.getItem('sf_customer_token')) { setLoading(false); return; }
    PORTAL.get('/orders').then(r => { setOrders(r.data.orders || []); setCurrency(r.data.currency || 'INR'); }).finally(() => setLoading(false));
  }, []);

  if (!ready || loading) return <div style={{ padding: 60, textAlign: 'center', color: '#aaa' }}>Loading…</div>;
  if (!customer) return (
    <div style={{ maxWidth: 500, margin: '60px auto', textAlign: 'center' }}>
      <h2>Please sign in to view your orders</h2>
      <Link to={`${STORE_BASE}/login`} style={{ color: 'var(--sf-accent)' }}>Sign in</Link>
    </div>
  );

  const downloadPricelist = () => {
    window.open(`/api/portal/pricelist/download?token=${localStorage.getItem('sf_customer_token')}`, '_blank');
    trackEvent('catalogue_download', { format: 'xlsx' });
  };

  return (
    <div style={{ maxWidth: 900, margin: '24px auto', padding: '0 24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 10 }}>
        <h1 style={{ fontSize: 24, fontWeight: 700, margin: 0 }}>My Orders</h1>
        {customer.price_visible && (
          <button onClick={downloadPricelist} className="sf-btn-outline" style={{ padding: '9px 18px',
            border: '1.5px solid var(--sf-accent)', borderRadius: 8, fontSize: 13.5, fontWeight: 600, cursor: 'pointer' }}>
            ↓ Download My Pricelist
          </button>
        )}
      </div>
      {orders.length === 0 ? (
        <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 40, textAlign: 'center', color: '#999' }}>
          No orders yet. <Link to={`${STORE_BASE}/shop`} style={{ color: 'var(--sf-accent)' }}>Start shopping</Link>
        </div>
      ) : (
        <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, overflow: 'hidden' }}>
          {orders.map((o, i) => (
            <Link key={o.id} to={`${STORE_BASE}/orders/${o.id}`} style={{
              display: 'flex', alignItems: 'center', gap: 16, padding: '14px 18px',
              borderTop: i ? '1px solid #f2f2f2' : 'none', textDecoration: 'none', color: 'inherit', cursor: 'pointer',
            }}
              onMouseEnter={e => e.currentTarget.style.background = '#fafafa'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600 }}>{o.order_number}</div>
                <div style={{ fontSize: 12.5, color: '#888' }}>{new Date(o.created_at).toLocaleDateString()} · {o.items_count} item(s)</div>
              </div>
              <span style={{ fontSize: 12, padding: '3px 10px', borderRadius: 12, background: '#f1f5f9', color: '#475569', textTransform: 'capitalize' }}>{o.status}</span>
              <span style={{ fontSize: 12, padding: '3px 10px', borderRadius: 12, background: '#fff7ed', color: PAY_COLOR[o.payment_status] || '#666' }}>
                {PAY_LABEL[o.payment_status] || o.payment_status}
              </span>
              <div style={{ fontWeight: 700, minWidth: 90, textAlign: 'right' }}>{currency} {Number(o.total_amount).toLocaleString()}</div>
              <i className="ti ti-chevron-right" style={{ fontSize: 16, color: '#bbb' }} />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
